/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { classNames as d, IconWrap as c } from "@progress/kendo-react-common";
const I = (e) => {
  const i = t.useCallback(
    (l) => {
      e.onClick(l, e.index);
    },
    [e]
  ), a = e.dataItem.render || e.item || (e.item === void 0 ? e.render : null), n = e.dataItem.text !== void 0 ? e.dataItem.text : e.textField ? e.dataItem[e.textField] : e.dataItem, m = /* @__PURE__ */ t.createElement(
    "li",
    {
      id: e.id,
      className: d(
        "k-item",
        e.className,
        { "k-focus": e.focused }
      ),
      tabIndex: -1,
      onClick: i,
      onMouseDown: e.onDown,
      onPointerDown: e.onDown,
      role: "menuitem",
      "aria-disabled": e.dataItem.disabled || void 0
    },
    /* @__PURE__ */ t.createElement(
      "span",
      {
        tabIndex: -1,
        className: d(
          "k-link k-menu-link",
          {
            "k-selected": e.dataItem.selected,
            "k-disabled": e.dataItem.disabled
          }
        ),
        key: "icon"
      },
      a ? /* @__PURE__ */ t.createElement(a, { item: e.dataItem, itemIndex: e.index }) : /* @__PURE__ */ t.createElement(t.Fragment, null, (e.dataItem.icon || e.dataItem.iconClass || e.dataItem.svgIcon) && /* @__PURE__ */ t.createElement(c, { className: e.dataItem.iconClass, name: e.dataItem.icon, icon: e.dataItem.svgIcon }), e.dataItem.imageUrl && /* @__PURE__ */ t.createElement(
        "img",
        {
          role: "presentation",
          alt: "",
          src: e.dataItem.imageUrl,
          className: "k-icon"
        }
      ), n && /* @__PURE__ */ t.createElement("span", { className: "k-menu-link-text" }, n))
    )
  );
  return e.item !== void 0 && /* to be removed in 5.0.0 */
  e.render !== void 0 ? e.render.call(void 0, m, e) : m;
};
I.displayName = "KendoReactButtonItem";
export {
  I as ButtonItem
};
